// Vue
import '@/main.css';
// import '@/core/js/Copyright.js';
import { createApp } from 'vue';

// Vue meta
import { createMetaManager } from 'vue-meta';

// Focus Trap
import { FocusTrap } from 'focus-trap-vue';

// Core
import { getRouter } from '@/core/js/Route.js';

// Mixins
import CommonsMixin from '@/mixins/Commons.js';

// Global components
import Icon from '@/components/icon/Icon.vue';
import Btn from '@/components/btn/Btn.vue';
import Cover from '@/components/cover/Cover.vue';

// Main app
import App from './App.vue';

// window.lazySizesConfig = window.lazySizesConfig || {};
// window.lazySizesConfig.init = false;

import VueGoogleMaps from "vue-google-maps-community-fork";

// Directives
const clickOutside = {
    beforeMount(element, binding) {
        //  check that click was outside the el and his children
        element.clickOutsideEvent = (event) => {
            // and if it did, call method provided in attribute value
            if (!(element === event.target || element.contains(event.target))) {
                binding.value(event);
            }
        };
        document.body.addEventListener('click', element.clickOutsideEvent);
    },
    unmounted(element) {
        document.body.removeEventListener('click', element.clickOutsideEvent);
    },
};

(async () => {
    try {
        // create vue
        const router = await getRouter();

        const app = createApp(App);

        app.mixin(CommonsMixin);

        app.component('Icon', Icon);
        app.component('Btn', Btn);
        app.component('Cover', Cover);
        app.component('FocusTrap', FocusTrap);

        // app.config.globalProperties.productionTip = false
        app.use(router);
        app.use(createMetaManager());
        app.directive('click-outside', clickOutside);

        app.use(VueGoogleMaps, {
            load: {
                key: 'AIzaSyAFmRKPe_f1RopmW6ZQXsQ22Vvm3zyCjek',
            },
        })
        router.app = app;
        app.mount('#App');
    } catch (e) {
        // eslint-disable-next-line no-console
        console.trace(e.stack);
    }
})();
